import React from 'react';
import { ScreeningFlowContext } from 'providers/ScreeningFlowProvider';

export function useScreeningFlow() {
  return React.useContext(ScreeningFlowContext);
}
